import { PageLayout } from '../../components/layout';
import WaitlistReferralGenerator from './WaitlistReferralGenerator';

export default function WaitlistQrManagementPage() {
  return (
    <PageLayout
      title="Waitlist QR Management"
      subtitle="Generate branded referral QR codes and manage existing waitlist links."
    >
      <div className="p-5 sm:p-6">
        <WaitlistReferralGenerator />
      </div>
    </PageLayout>
  );
}
